import { bus_bangkiemtuanthu } from '../../models/response/bus/bus_bangkiemtuanthu';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_BANGKIEMTUANTHU_PATH = "bus/bang-kiem-tuan-thu";

class BusBangKiemTuanThuApi extends BaseCRUDApi<bus_bangkiemtuanthu> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/bus/bang-kiem-tuan-thu`);
	}
}
export const busBangKiemTuanThuApi = new BusBangKiemTuanThuApi(API_BUS_BANGKIEMTUANTHU_PATH);
